import type {
  AssetTreeNode,
  AssetTreeNodeLocation,
  AssetTreeNodeOrganization,
  AssetTreePayload,
  UseGetTreeOptions,
  UseGetTreeProps,
} from "./asset-tree.type";
import type { ApiError } from "@/services/api";
import type { Int } from "@/types";

import { useQuery } from "@tanstack/react-query";

import { client } from "@/config/client";

export const useGetTree = <Node = AssetTreeNode>({
  endpoint,
  id,
  enabled,
  ...options
}: UseGetTreeProps<Node>) => {
  const { data, ...queryResult } = useQuery<AssetTreePayload<Node>, ApiError>({
    queryKey: ["tree", endpoint, id],
    queryFn: () => client[endpoint].tree(id),
    refetchOnWindowFocus: false,
    enabled: enabled ?? !!id,
    ...options,
  });

  return {
    tree: data?.data?.data ?? [],
    ...queryResult,
  };
};

export const useGetOrganizationTree = (
  organizationId: Int,
  options?: UseGetTreeOptions<AssetTreeNodeOrganization>
) => {
  return useGetTree<AssetTreeNodeOrganization>({
    endpoint: "organizations",
    id: organizationId,
    ...options,
  });
};

export const useGetLocationTree = (
  locationId: Int,
  options?: UseGetTreeOptions<AssetTreeNodeLocation>
) => {
  return useGetTree<AssetTreeNodeLocation>({
    endpoint: "locations",
    id: locationId,
    ...options,
  });
};
